module.exports = __webpack_public_path__ + "img/IMG_Phone_1.aee78443.jpg";